import { Trans } from "@lingui/macro";
import { useState } from "react";
import { FaWallet } from "react-icons/fa";

import { CustodyWalletModal } from "./CustodyWalletModal";

import "./CustodyWalletButton.scss";

type Props = {
  small?: boolean;
};

export function CustodyWalletButton({ small }: Props) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const custodyWallet = localStorage.getItem("custodyWallet");

  if (!custodyWallet) {
    return null;
  }

  return (
    <>
      <button
        className="custody-wallet-btn"
        onClick={() => setIsModalVisible(true)}
        data-qa="custody-wallet-button"
      >
        <FaWallet className="custody-wallet-icon" />
        {!small && <span className="custody-wallet-text">Custody Wallet</span>}
      </button>
      
      <CustodyWalletModal
        isVisible={isModalVisible}
        setIsVisible={setIsModalVisible}
        custodyWalletAddress={custodyWallet}
      />
    </>
  );
}